





































import Vue from 'vue';
import { Component, Emit } from 'vue-property-decorator';
import dxNumberBox from 'devextreme/ui/number_box';
import { DxNumberBox } from 'devextreme-vue/number-box';
import { DxPopup, DxToolbarItem } from 'devextreme-vue/popup';
import { DxRequiredRule, DxValidator } from 'devextreme-vue/validator';
import { InvoiceLookupLineItemDto } from '@/models/invoice/InvoiceLookupLineItemDto';

@Component({
  components: {
    DxNumberBox,
    DxPopup,
    DxRequiredRule,
    DxToolbarItem,
    DxValidator
  }
})
export default class EditLineItemTotal extends Vue {
  private readonly title: string = 'Change Line Item Amount';
  private numberBox: dxNumberBox | undefined;
  private originalValue: number = 0;
  private showDialog: boolean = false;

  public dialogResult: boolean | null = null;
  public lineItem: InvoiceLookupLineItemDto | null = null;
  public value: number = 0;
  public valueChanged: boolean = false;

  private get okButtonOptions() {
    return {
      text: 'OK',
      type: 'default',
      stylingMode: 'contained',
      onClick: this.ok
    };
  }

  private get cancelButtonOptions() {
    return {
      text: 'Cancel',
      type: 'normal',
      stylingMode: 'contained',
      onClick: this.cancel
    };
  }

  public show() {
    this.showDialog = true;
  }

  private ok() {
    if (this.isValid()) {
      this.close(true);
    }
  }

  private isValid() {
    if (this.numberBox == null) {
      return true;
    }

    return this.numberBox.option('isValid') as boolean;
  }

  private cancel() {
    this.close(false);
  }

  private close(dialogResult: boolean) {
    this.dialogResult = dialogResult;
    this.showDialog = false;
  }

  private onShowing() {
    this.dialogResult = null;
    this.originalValue = this.value;
  }

  @Emit('hiding')
  private onHiding() {
    this.valueChanged = this.value !== this.originalValue;
    return this.dialogResult;
  }

  private onNumberBoxInitialized(e: any) {
    this.numberBox = e.component;
  }
}
